function stamp(value) { const n = value ? Date.parse(value) : NaN; return Number.isFinite(n) ? n : null; }
export function eventFeed(data, now = Date.now()) {
  const records = [];
  for (const r of data.reentries || []) {
    const time = stamp(r.decay_epoch), ahead = time === null ? Infinity : time - now;
    records.push({id:`reentry:${r.norad_id}`,type:'reentry',label:'Reentry',name:r.name || `NORAD ${r.norad_id}`,time,
      priority:ahead >= 0 && ahead < 6*3600000,raw:r,
      extra:Number.isFinite(r.uncertainty_days) ? `Predicted · ±${r.uncertainty_days} days` : 'Predicted reentry'});
  }
  for (const l of data.launches || []) {
    const time = stamp(l.net), ahead = time === null ? Infinity : time - now;
    records.push({id:`launch:${l.id}`,type:'launch',label:'Launch',name:l.name || l.mission || l.vehicle || 'Launch',time,
      priority:ahead >= 0 && ahead < 3600000,raw:l,extra:[l.status,l.pad_location || l.pad_name].filter(Boolean).join(' · ')});
  }
  for (const c of data.conjunctions || []) {
    const time = stamp(c.tca);
    records.push({id:`conjunction:${c.norad_1}:${c.norad_2}:${c.tca}`,type:'conjunction',label:'Conjunction',name:`${c.name_1 || c.norad_1} / ${c.name_2 || c.norad_2}`,time,
      priority:time !== null && time >= now && c.probability >= 1e-3,raw:c,extra:c.probability != null ? `Collision probability ${Number(c.probability).toExponential(1)}` : 'Closest approach'});
  }
  return records.map(r=>({...r,search:[r.name,r.label,r.raw.norad_id,r.raw.norad_1,r.raw.norad_2,r.raw.vehicle,r.raw.pad_name,r.raw.pad_location].filter(Boolean).join(' ').toLowerCase()}));
}
export function filterEvents(records, filters, now = Date.now()) {
  const base = records.filter(r=>filters.period === 'past' ? r.time !== null && r.time < now : r.time === null || r.time >= now);
  const query = filters.query.trim().toLowerCase();
  const items = base.filter(r=>(filters.type==='all'||r.type===filters.type) && (!query||r.search.includes(query)) &&
    (filters.priority==='all'||(filters.priority==='high'?r.priority:r.time!==null&&r.time>=now&&r.time<=now+86400000)));
  items.sort((a,b)=>a.time===null ? (b.time===null ? a.id.localeCompare(b.id) : 1) : b.time===null ? -1 : (filters.period==='past'?b.time-a.time:a.time-b.time)||a.id.localeCompare(b.id));
  return {items,total:base.length};
}
export function relativeEvent(time, now = Date.now()) {
  if (time === null) return 'Time TBD';
  const difference=time-now,minutes=Math.max(1,Math.round(Math.abs(difference)/60000));
  const duration=minutes<60?`${minutes}m`:minutes<2880?`${Math.floor(minutes/60)}h`:`${Math.floor(minutes/1440)}d`;
  return difference>=0?`in ${duration}`:`${duration} ago`;
}
export const DEFAULT_EVENT_FILTERS = {query:'',type:'all',period:'upcoming',priority:'all'};
